/**
 * Multiline.js
 *
 * @class   Multiline
 * @author  Dan Goldshlack
 *
 */

import React from 'react';
import D3 from 'd3';

export default React.createClass({

	displayName: 'Multiline',

	propTypes: {

	},

	render() {

		return <h3>Multiline</h3>

	}

});



/** WEBPACK FOOTER **
 ** ./src/charts/multiline/Multiline.js
 **/